var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, useMediaQuery } from "@mui/material";
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppDispatch } from "../../../store/hooks";
import { faintGray } from "../../../theme/palette";
import { getLocalStorageItem, setLocalStorageItem } from "../../../utils/storageHelper";
import { VehicleListAPI } from "../../NewPDICheck/services/apiCalls";
import { postingTypeListAPI, serviceAdvisorListAPI } from "../services/apiCall";
import { JobCardInvoicesKeys } from "../services/entity";
var JCIFilter = function (_ref) {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3;
    var data = _ref.data, onClose = _ref.onClose;
    var FILTER_APPLY_FLAG = 'APPLIED';
    var dispatch = useAppDispatch();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var organizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var userOrganizationID = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.Branches[0]) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.ParentOrganizationId;
    var arrayResponse = [_objectSpread({}, storedSelectedBranch)];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: isMobile ? '16px 0px' : 0,
            columnSize: 12,
            mt: IS_DESKTOP ? 10 : 0,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Filters',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            spacing: 0,
            columnSize: 12,
            gap: 2,
            paddingBottom: '80px',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'OrganizationId',
                    label: 'Branch',
                    options: arrayResponse,
                    displayExpr: 'OrganizationName',
                    valueExpr: 'OrganizationId',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PostingTypeId',
                    label: 'PostingType',
                    getListData: postingTypeListAPI,
                    apiKey: JobCardInvoicesKeys.PostingTypeListKeys,
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceAdvisorId',
                    label: 'Service advisor',
                    getListData: serviceAdvisorListAPI,
                    apiRequest: {
                        BranchId: organizationId
                    },
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.GivenName) + " " + (option === null || option === void 0 ? void 0 : option.FamilyName); },
                    displayExpr: 'Name',
                    valueExpr: 'UserId',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ProductId',
                    label: 'Vehicle model',
                    getListData: VehicleListAPI,
                    apiRequest: {
                        request: {
                            OrganizationId: organizationId,
                            SystemName: "Product"
                        }
                    },
                    displayExpr: 'DisplayName',
                    valueExpr: 'id',
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'InvoiceStartDate',
                            label: 'Date',
                            value: null,
                            columnSize: 6,
                            placeholder: 'From',
                            // disablePast: true,
                            // disableFuture: false,
                            required: false,
                            setFormState: function () { return ({
                                InvoiceEndDate: null
                            }); }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'InvoiceEndDate',
                            label: 'To',
                            value: null,
                            columnSize: 6,
                            placeholder: 'To',
                            required: false
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            width: {
                xs: '400px'
            },
            justifyContent: 'space-between',
            position: 'fixed',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            borderTop: "1px solid ".concat(faintGray),
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: 'Reset filters',
                    columnSize: 0,
                    sx: {
                        color: 'secondary.600',
                        borderColor: 'secondary.600'
                    },
                    setFormState: function (formValues, currValue, field) {
                        return {
                            ProductId: null,
                            ServiceAdvisorId: null,
                            PostingTypeId: null,
                            OrganizationId: null,
                            InvoiceStartDate: null,
                            InvoiceEndDate: null
                        };
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Apply',
                    columnSize: 0,
                    setFormState: function (formValues, currValue, field) { return (setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_APPLY, FILTER_APPLY_FLAG), {}); },
                    onClick: function (event, formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            onClose({
                                ApplyFilter: 'Filter',
                                formData: formValues
                            });
                            return [2 /*return*/];
                        });
                    }); }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        padding: 3
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData
    })));
};
export default JCIFilter;
